"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var loadedUrls = {};

var Prefetcher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Prefetcher, _React$Component);

  function Prefetcher(props) {
    var _this;

    _classCallCheck(this, Prefetcher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Prefetcher).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_delay", _this.props.delayMs || 500);

    _defineProperty(_assertThisInitialized(_this), "timeoutHandles", []);

    _defineProperty(_assertThisInitialized(_this), "_eventHappened", function (event) {
      return _this.timeoutHandles.push(setTimeout(function () {
        return _this.setState(_defineProperty({}, event + 'ed', true));
      }, _this._delay));
    });

    _defineProperty(_assertThisInitialized(_this), "_prefetchAssets", function (assets) {
      if (!assets) {
        return null;
      }

      if (assets.constructor !== Array) {
        return _this._renderPrefetch(assets);
      }

      return assets.map(_this._renderPrefetch).filter(Boolean);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderPrefetch", function (href) {
      if (_typeof(href) === 'object') {
        _this._processCustomFetcher(href);

        return null;
      }

      if (!href || loadedUrls[href]) {
        return;
      }

      return _react["default"].createElement("link", {
        key: href,
        rel: "prefetch",
        href: href,
        onLoad: function onLoad() {
          return loadedUrls[href] = true;
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_processCustomFetcher", function (config) {
      if (typeof config.fetcher !== 'function') {
        console.warn('Invalid config to prefetch:', config);
        return;
      }

      if (loadedUrls[config.href]) {
        return;
      }

      config.fetcher();
      loadedUrls[config.href] = true;
    });

    _this.state = {
      rendered: false,
      hovered: false,
      clicked: false
    };
    return _this;
  }

  _createClass(Prefetcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._eventHappened('render');
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.timeoutHandles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var handle = _step.value;
          clearTimeout(handle);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator["return"] != null) {
            _iterator["return"]();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react["default"].createElement(_react.Fragment, null, this.props.children && _react["default"].createElement("span", {
        onMouseEnter: function onMouseEnter() {
          return _this2._eventHappened('hover');
        },
        onClick: function onClick() {
          return _this2._eventHappened('click');
        },
        className: this.props.className,
        style: _objectSpread({
          width: 'max-content'
        }, this.props.style)
      }, this.props.children), this.state.rendered && this._prefetchAssets(this.props.onRenderAssets), this.state.hovered && this._prefetchAssets(this.props.onHoverAssets), this.state.clicked && this._prefetchAssets(this.props.onClickAssets));
    }
  }]);

  return Prefetcher;
}(_react["default"].Component);

exports["default"] = Prefetcher;